/* tslint:disable */
/* eslint-disable */
/**
 * CVAT REST API
 * REST API for Computer Vision Annotation Tool (CVAT)
 *
 * The version of the OpenAPI document: 2.31.0
 * Contact: support@cvat.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * * `any` - ANY * `cuboid` - CUBOID * `ellipse` - ELLIPSE * `mask` - MASK * `points` - POINTS * `polygon` - POLYGON * `polyline` - POLYLINE * `rectangle` - RECTANGLE * `skeleton` - SKELETON * `tag` - TAG
 * @export
 * @enum {string}
 */

export const LabelType = {
    Any: 'any',
    Cuboid: 'cuboid',
    Ellipse: 'ellipse',
    Mask: 'mask',
    Points: 'points',
    Polygon: 'polygon',
    Polyline: 'polyline',
    Rectangle: 'rectangle',
    Skeleton: 'skeleton',
    Tag: 'tag'
} as const;

export type LabelType = typeof LabelType[keyof typeof LabelType];



